export default __webpack_public_path__ + "static/male-8efe1ac46adf8ba26d83d3e9747db260.png";